<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yjpArV/tc-custom/9780310346647.jpg?1728327117363" alt="This image is the cover for the book Help Is on the Way"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Help Is on the Way
      </h1>
      <p class="bookDescription body article font2">
        <p>Disappointed dreams, broken relationships, identity crises, vocational hang-ups, wounds from the past--there are so many ways life can send us crashing up against the rocks.</p><p>So when life leaves you shipwrecked, what can you do? In <i>Help Is On the Way, </i>excerpted from his full-length book <i>How to Survive a Shipwreck, </i>author and pastor Jonathan Martin draws from his own shipwreck experiences to uncover how God meets us in our most critical moment, and exactly what we need to hang on until morning. Through fresh biblical insights and strong practical truth, <i>Help Is On the Way </i>will illuminate:</p>How to practice self-care in the midst of a shipwreck (and why this is <i>not</i> selfish)What to hold on to at all costs, and what to let goHow to gain clarity, composure, and a new way of knowing God on the other side of the stormWhere God's love is in all of this--even the hard parts
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jonathan Martin
      </h2>
      
      <p class="authorDescription body article"><P>Jonathan Martin is a writer, speaker, and dreamer currently living in Tulsa, OK, where he serves as Teaching Pastor at Sanctuary Church. He holds degrees from Gardner-Webb University, The Pentecostal Theological Seminary, and Duke Divinity School. He is the author of Prototype: What Happens When You Discover You&rsquo;re More Like Jesus Than You Think? He is a product of the &ldquo;Christ-haunted landscape&rdquo; of the American South, sweaty revivals, and hip-hop. Years before a life of church planting, writing, and preaching, his claim to fame was getting his Aquaman, Robin, and Wonder Woman action figures saved, sanctified, and filled with the Holy Ghost at an early age. He loves to talk about the beauty of God, what an extraordinary thing it is to be called God&rsquo;s beloved, and finding new ways to be human.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f4fc4538